// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-listen-js": () => import("./../src/pages/Listen.js" /* webpackChunkName: "component---src-pages-listen-js" */),
  "component---src-pages-thank-you-js": () => import("./../src/pages/ThankYou.js" /* webpackChunkName: "component---src-pages-thank-you-js" */)
}

